<script>
	// The params prop contains values matched from the URL
	export let params = {}

	import { createEventDispatcher, onMount } from 'svelte';
	import { push } from 'svelte-spa-router';
	import TBox from './templates/TBox.svelte';
	import BarraPaginacao from '../componentes/BarraPaginacao.svelte';
	import { sTema } from '../stores';
	import { 
		API, 
		TipoEvento,
		StatusHttp } from '../utils';
	
	const dispatch = createEventDispatcher();
	let parseProjetos = [];
	let paginaAnterior, paginaAtual, proximaPagina, totalResultados, ultimaPagina, resultadosPorPagina;
	let visibilidadePainel = false;
	let endpoint = "";

	onMount(async () => {
		$sTema = "dia";	
		carregarProjetosAPI(1, endpoint);
	});

	const carregarProjetosAPI = async (pagina) => {
		parseProjetos = [];
		visibilidadePainel = false;

		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando dados ...',
		});

		if (params.tipoConsulta == 'MODALIDADE_PROJETO')
			endpoint = "sdg/trabalhos/listagem/modalidade";
		else if (params.tipoConsulta == 'AREA_ATUACAO_PROJETO')
			endpoint = "sdg/trabalhos/listagem/area";
		else
			push("#/parametro-invalido");

		const resposta = await fetch(API(`${endpoint}?ano=${params.ano}&termo=${params.termo}&page=${pagina}`)).catch(erros => {
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: 'Erro interno no servidor, tente novamente mais tarde.'
			});

			push("#/erro-na-requisicao");
		});
		
		const json = await resposta.json();
		
		if (resposta.status == StatusHttp.OK) {
			let { dados: { meta, data } } = json;

			// atribui os valores da resposta da paginação atual (estas atribuições devem ocorrer antes de adicionar valores no parseProjetos com o push pois caso contrário a referência a página atual fica errada / atrasada)
			paginaAtual = meta.current_page;
			paginaAnterior = paginaAtual - 1;
			proximaPagina = paginaAtual + 1;
			totalResultados = meta.total;
			ultimaPagina = meta.last_page;
			resultadosPorPagina = meta.per_page;
			
			data.forEach( projeto => {
				parseProjetos.push({
					codigo: projeto.codigo,
					titulo: projeto.titulo,
					modalidade: projeto.modalidade,
					data_criacao: projeto.data_criacao,
                    apresentacoes: [ ... projeto.apresentacoes]
				});
			});

			parseProjetos = [...parseProjetos];
		} else {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: json?.mensagem
			});
			
			// desabilitar tela de loading antes do replace, caso contrário, em situações de erro, a tela de loading não deixa de ser exibida.
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			push("#/sdg/trabalhos");
		}

		// repete esconder tela de loading em caso de requisição ok
		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
		
		visibilidadePainel = true;
	}
</script>

<TBox 
	titulo="Resultado da Consulta" 
	subtitulo="Utilize o menu abaixo para navegar pelos registros"
	largura="12" 
	icone="buscar"
	visivel={visibilidadePainel}
	deslocamento="0">

	<BarraPaginacao 
		callback={carregarProjetosAPI}
		paginaAnterior={paginaAnterior}
		paginaAtual={paginaAtual}
		proximaPagina={proximaPagina}
		ultimaPagina={ultimaPagina}
		totalResultados={totalResultados}
		resultadosPorPagina={resultadosPorPagina}
		margemInferior={false}/>

	<div class="container_tabela">
		<table class="table is-fullwidth is-hoverable">
			<thead>
				<tr>
					<th>Título</th>
					<th>Modalidade</th>
					<th>Data cadastro</th>
					<th>Apresentações SDG (anos)</th>
				</tr>
			</thead>
			<tbody>
			{#each parseProjetos as item}
				<tr>
					<td>{ item.titulo }</td>
					<td>{ item.modalidade }</td>
					<td>{ item.data_criacao }</td>
                    <td>
                        {#each item?.apresentacoes as apresentacao}
                        <a href="#/sdg/trabalhos/visualizar/resumo/{apresentacao?.id}/{item?.codigo}" target="_blank">{apresentacao?.ano} (abrir resumo)</a>
                        <br>
                        {:else}
                        <p>Sem apresentação cadastrada.</p>
                        {/each}
                    </td>
				</tr>
				{:else}
				<td colspan="3">Nenhum registro encontrado.</td>
			{/each}
			</tbody>
		</table>
	</div>

	<hr>

	<div class="columns">
		<div class="column is-3">
			<p class="control">
				<a href="#/sdg/trabalhos" class="button is-black is-medium is-outlined is-fullwidth">Voltar</a>
			</p>
		</div>
	</div>
</TBox>